import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ErrorScreen } from '@/components/shared/error-screen'

/** Branded error boundary for every layout route (no blank screens). */
export function RouteError() {
  const error = useRouteError()
  const status = isRouteErrorResponse(error) ? error.status : 500
  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : 'Something went wrong.'
  return (
    <ErrorScreen
      code={status}
      title={status === 404 ? 'This line’s gone dead.' : 'Something went wrong on our end.'}
      message={message}
      to="/"
      action="Back to the dashboard"
    />
  )
}
